import general from '@infotrack/presentacion-transversales/recursos/idiomas/en_US';

import maximosMinimos from './maximosMinimos';
import pedidos from './alistamiento';
import almacenamiento from './almacenamiento';
import aplicacionEstilo from './aplicacionEstilo';
import auditoriasInventario from './auditoriasInventario';
import banco from './banco';
import barraLateral from './barraLateral';
import base from './base';
import bodegasTiposPropiedades from './bodegasTiposPropiedades';
import clasesTecnicas from './clasesTecnicas';
import clasificaciones from './clasificaciones';
import clientes from './clientes';
import columnas from './columnas';
import consultaInventario from './consultaInventario';
import despachos from './despachos';
import detallesFormulario from './detallesFormulario';
import detallesInventario from './detallesInventario';
import devoluciones from './devoluciones';
import devolucionProveedor from './devolucionProveedor';
import divisionesTiposPropiedades from './divisionesTiposPropiedades';
import documentoBuscador from './documentoBuscador';
import documentos from './documentos';
import documentoValorTotal from './documentoValorTotal';
import entradaDevolucion from './entradaDevolucion';
import entradaInventario from './entradaInventario';
import estadosDetalles from './estadosDetalles';
import etapas from './etapas';
import fabricantes from './fabricantes';
import familias from './familias';
import filas from './filas';
import flujos from './flujos';
import flujosEtapas from './flujosEtapas';
import formularioDocumento from './formularioDocumento';
import gestionAuditorias from './gestionAuditorias';
import gestionBodegas from './gestionBodegas';
import gestionCompras from './gestionCompras';
import gestionOperador from './gestionOperador';
import gestionPedidos from './gestionPedidos';
import gestionProducto from './gestionProducto';
import grupoActividadEconomica from './grupoActividadEconomica';
import informes from './informes';
import marcas from './marcas';
import modalSeriales from './modalSeriales';
import modulo from './modulo';
import monitorInventarios from './monitorInventarios';
import monitorPedidos from './monitorPedidos';
import ordenEntrada from './ordenEntrada';
import ordenSalida from './ordenSalida';
import pais from './pais';
import perfil from './perfil';
import permisos from './permisos';
import persona from './persona';
import pisos from './pisos';
import productos from './productos';
import proveedores from './proveedores';
import recepcion from './recepcion';
import referencias from './referencias';
import resolucionesFacturaciones from './resolucionesFacturaciones';
import reversion from './reversion';
import salidaInventario from './salidaInventario';
import tablaDetalles from './tablaDetalles';
import tablaDetallesPlantilla from './tablaDetallesPlantilla';
import tablaDocumentos from './tablaDocumentos';
import tipoContribuyente from './tipoContribuyente';
import tipoCuentaBancaria from './tipoCuentaBancaria';
import tipoIdentificacion from './tipoIdentificacion';
import tipoRegimen from './tipoRegimen';
import tiposBodegas from './tiposBodegas';
import tiposClientes from './tiposClientes';
import tiposDivisiones from './tiposDivisiones';
import tiposDocumento from './tiposDocumento';
import tiposMovimientos from './tiposMovimientos';
import tipoSociedad from './tipoSociedad';
import tiposUnidades from './tiposUnidades';
import traslados from './traslados';
import unidades from './unidades';
import usuario from './usuario';
import modalFlujos from './modalFlujos';
import flujoFormulario from './flujoFormulario';
import formularioFlujoEtapas from './formularioFlujoEtapas';
import flujosTabla from './flujoTabla';
import plantillaImpresion from './plantillaImpresion';
import agencia from '@infotrack/presentacion-modulosbase/transversales/internacionalizacion/idiomas/es_US/agencia';
import documentoEvidencias from './documentoEvidencias';
import impresion from './impresion';
import etiquetaItems from './etiquetaItems';
import cargaMasiva from './cargaMasiva';
import ordenTraslado from './ordenTraslados'
import catalogo from '@infotrack/presentacion-modulosbase/transversales/internacionalizacion/idiomas/es_US/catalogo';
import generarPDF from './generarPDF';
import documentoFirma from './documentoFirma';
 
export default {
    ...maximosMinimos,
    ...agencia,
    ...almacenamiento,
    ...aplicacionEstilo,
    ...auditoriasInventario,
    ...banco,
    ...barraLateral,
    ...base,
    ...bodegasTiposPropiedades,
    ...clasesTecnicas,
    ...clasificaciones,
    ...clientes,
    ...columnas,
    ...consultaInventario,
    ...despachos,
    ...detallesFormulario,
    ...detallesInventario,
    ...devoluciones,
    ...devolucionProveedor,
    ...divisionesTiposPropiedades,
    ...documentoBuscador,
    ...documentos,
    ...entradaDevolucion,
    ...entradaInventario,
    ...estadosDetalles,
    ...etapas,
    ...fabricantes,
    ...familias,
    ...filas,
    ...flujos,
    ...flujosEtapas,
    ...formularioDocumento,
    ...general,
    ...gestionAuditorias,
    ...gestionBodegas,
    ...gestionCompras,
    ...gestionOperador,
    ...gestionPedidos,
    ...gestionProducto,
    ...grupoActividadEconomica,
    ...informes,
    ...marcas,
    ...modalSeriales,
    ...modulo,
    ...monitorInventarios,
    ...monitorPedidos,
    ...ordenEntrada,
    ...ordenSalida,
    ...pais,
    ...pedidos,
    ...perfil,
    ...permisos,
    ...persona,
    ...pisos,
    ...productos,
    ...proveedores,
    ...recepcion,
    ...referencias,
    ...resolucionesFacturaciones,
    ...reversion,
    ...salidaInventario,
    ...tablaDetalles,
    ...tablaDetallesPlantilla,
    ...tablaDocumentos,
    ...tipoContribuyente,
    ...tipoCuentaBancaria,
    ...tipoIdentificacion,
    ...tipoRegimen,
    ...tiposBodegas,
    ...tiposClientes,
    ...tiposDivisiones,
    ...tiposDocumento,
    ...tiposMovimientos,
    ...tipoSociedad,
    ...tiposUnidades,
    ...traslados,
    ...unidades,
    ...usuario,
    ...documentoValorTotal,
    ...modalFlujos,
    ...flujoFormulario,
    ...formularioFlujoEtapas,
    ...flujosTabla,
    ...plantillaImpresion,
    ...documentoEvidencias,
    ...cargaMasiva,
    ...etiquetaItems,
    ...cargaMasiva,
    ...ordenTraslado,
    ...impresion,
    ...catalogo,
    ...generarPDF,
    ...documentoFirma
};
